module.exports = __webpack_public_path__ + "img/_blog7.b6d21cbf.jpg";